module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper main-container"
  }, [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tabs', [_c('tab', {
    attrs: {
      "name": "Failed Transactions",
      "selected": true
    }
  }, [_c('FailedTransactionTabView', {
    attrs: {
      "emptyTransactionsMessage": _vm.emptyTransactionsMessage,
      "actionName": "Archive",
      "transactions": _vm.transactions,
      "goToViewDetail": _vm.goToViewDetail,
      "handleArchiveUnarchiveTransaction": _vm.handleArchiveTransaction
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Archived"
    }
  }, [_c('FailedTransactionTabView', {
    attrs: {
      "emptyTransactionsMessage": _vm.emptyArchivedTransactionsMessage,
      "actionName": "Unarchive",
      "transactions": _vm.archivedTransactions,
      "goToViewDetail": _vm.goToViewDetail,
      "handleArchiveUnarchiveTransaction": _vm.handleUnarchiveTransaction
    }
  })], 1)], 1)], 1)])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Cancelled/Failed transactions\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n              Transaction list\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12c26dad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FailedTransactionList.vue
// module id = 2106
// module chunks = 1